// extracted by mini-css-extract-plugin
export default {"container":"instruction_container__RrF50","para":"instruction_para__a0l+Q","btn":"instruction_btn__SeKGm"};